export interface ReferenceLabelEntry {
    status: "loading" | "resolved";
    label: string | null;
}

export interface ReferenceLabelState {
    [resource: string]: { [id: string]: ReferenceLabelEntry };
}

interface WithReferenceLabels {
    referenceLabels?: ReferenceLabelState;
}

/**
 * Select the cached resolution entry for a single (resource, id) pair, or
 * `undefined` when it has not been requested yet. Returns a stable reference for
 * unchanged entries so per-cell subscriptions only re-render when their own
 * label resolves.
 */
export const referenceLabelSelector =
    (resource?: string, id?: string) =>
    (state: WithReferenceLabels): ReferenceLabelEntry | undefined =>
        resource && id ? state.referenceLabels?.[resource]?.[id] : undefined;
